import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { FutureSecurity } from "../proto/generated/future";
import { futureTradeDataType } from "../pages/typings/options.typings";

export type StoreFutureExpiries = {
    current: FutureSecurity[],
    past: FutureSecurity[]
}

export interface FuturesStateType {
    expiries: Record<string, StoreFutureExpiries>,
    futuresData: Record<string, futureTradeDataType[]>
    selectedFuture?: FutureSecurity
}

const initialState: FuturesStateType = {
    expiries: {},
    futuresData: {}
}

const futuresSlice = createSlice({
    name: 'futures',
    initialState,
    reducers: {
        setFutureExpiries(state: FuturesStateType, action: PayloadAction<{
            token: string,
            data: Partial<StoreFutureExpiries>
        }>) {

            const {token, data} = action.payload
            return {
                ...state,
                expiries: {
                    ...state.expiries,
                    [token]: {
                        ...(state.expiries[token] || {current: [], past: []}),
                        ...data
                    }
                }
            }
        },
        setFutureExpiriesData(state: FuturesStateType, action: PayloadAction<{
            token: string,
            data: futureTradeDataType[]
        }>) {

            const {token, data} = action.payload
            return {
                ...state,
                futuresData: {
                    ...state.futuresData,
                    [token]: data
                }
            }
        },
        setSelectedFuture(state: FuturesStateType, action: PayloadAction<FutureSecurity>) {
            return {
                ...state,
                selectedFuture: action.payload
            }
        }
    },
})

const {actions, reducer} = futuresSlice

export const { setFutureExpiries, setSelectedFuture, setFutureExpiriesData } = actions


export default reducer